<template>
  <!-- 对话框 -->
  <el-drawer title="添加司机信息" :visible.sync="show" :with-header="false" :before-close="closeDialog" size="80%">

    <!-- 基本信息表单 -->
    <div class="form-box">



      <template>

        <el-form ref="form" :model="submit_data" label-width="80px" style="height: 90vh; overflow-y: auto;">

          <el-form-item label="封面图片:" label-width='120px'>


            <el-image :preview-src-list="srcList" v-if="img_url.cover_img_imageUrl" :src="img_url.cover_img_imageUrl"
              class="avatar"></el-image>
            <el-upload :class="img_url.cover_img_imageUrl?'border-none':''" class="avatar-uploader"
              :action="img_upload_url" :show-file-list="false" :on-success="coverImgSuccess"
              :before-upload="beforeAvatarUpload" :headers="img_headers">
              <el-button slot="trigger" v-if="img_url.cover_img_imageUrl" @click="img_url.cover_img_imageUrl='';"
                style="width: 100px; margin-top: 10px;">更换图片</el-button>
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>


          </el-form-item>



          <el-form-item label-width='100px'>


            <p class="text-red">*注：启动图广告（司机端）封面图片尺寸建议为750*1280</p>
            <p class="text-red">*注：启动图广告（乘客）封面图片尺寸建议为750*1280</p>
            <p class="text-red">*注：微信小程序(下部)封面图片尺寸建议为750*200</p>
            <p class="text-red">*注：钱包中间(乘客端)封面图片尺寸建议为750*280</p>
            <p class="text-red">*注：菜单栏左侧(乘客端)封面图片尺寸建议为750*200</p>
            <p class="text-red">*注：首页底部广告（乘客端）封面图片尺寸建议为750*360</p>
            <p class="text-red">*注：个人中心底部广告（司机端）封面图片尺寸建议为750*360</p>
            <p class="text-red">*注：首页底部广告（司机端）封面图片尺寸建议为750*360</p>


          </el-form-item>



          <el-form-item label="logo图片:" label-width='120px'>

            <el-image :preview-src-list="srcList" v-if="img_url.logo_img_imageUrl" :src="img_url.logo_img_imageUrl"
              class="avatar"></el-image>

            <el-upload :class="img_url.logo_img_imageUrl?'border-none':''" class="avatar-uploader"
              :action="img_upload_url" :show-file-list="false" :on-success="logoImgSuccess"
              :before-upload="beforeAvatarUpload" :headers="img_headers">
              <el-button slot="trigger" v-if="img_url.logo_img_imageUrl" @click="img_url.logo_img_imageUrl=''"
                style="width: 100px; margin-top: 10px;">更换图片</el-button>
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>


          </el-form-item>

          <el-form-item label="列表图片:" label-width='120px'>

            <el-image :preview-src-list="srcList" v-if="img_url.list_img_imageUrl" :src="img_url.list_img_imageUrl"
              class="avatar"></el-image>

            <el-upload :class="img_url.list_img_imageUrl?'border-none':''" class="avatar-uploader"
              :action="img_upload_url" :show-file-list="false" :on-success="listImgSuccess"
              :before-upload="beforeAvatarUpload" :headers="img_headers">
              <el-button slot="trigger" v-if="img_url.list_img_imageUrl" @click="img_url.list_img_imageUrl=''"
                style="width: 100px; margin-top: 10px;">更换图片</el-button>
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>

          </el-form-item>

          <el-form-item label="小程序原始id:" label-width='120px' v-if="submit_data.link_mode == '2'">
            <el-input v-model="submit_data.origin_appid" style="width: 80%;">
            </el-input>
          </el-form-item>

          <el-form-item label="小程序appid:" label-width='120px' v-if="submit_data.link_mode == '2'">
            <el-input v-model="submit_data.appid" style="width: 80%;">
            </el-input>
          </el-form-item>


          <el-form-item label="链接地址:" label-width='120px'>
            <el-input v-model="submit_data.link" :placeholder="submit_rules.link.placeholder" style="width: 80%;">
            </el-input>
          </el-form-item>

          <el-form-item label="广告名称:" label-width='120px'>
            <el-input v-model="submit_data.name" :placeholder="submit_rules.name.placeholder" style="width: 80%;">
            </el-input>
          </el-form-item>

          <el-form-item label="链接跳转模式:" label-width='120px'>
            <el-select v-model="submit_data.link_mode" placeholder="请选择" @change="typeChange">
              <el-option
                      label="不跳转"
                      value="0">
              </el-option>
              <el-option
                      label="跳转网页"
                      value="1">
              </el-option>
              <el-option
                      label="小程序"
                      value="2">
              </el-option>
              <el-option
                      label="内部链接"
                      value="3">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="内部链接地址:" v-if="submit_data.link_mode=='3'" label-width='120px'>
            <el-select v-model="submit_data.inside_link" placeholder="请选择">
              <el-option
                      v-for="item in insideLinkList"
                      :label="item.name"
                      :value="item.key">
              </el-option>

            </el-select>
          </el-form-item>



          <el-form-item label="广告内容:" label-width='120px'>

            <quill-editor ref="myTextEditor" v-model="submit_data.content" :options="submit_rules.content">
            </quill-editor>

          </el-form-item>

          <el-form-item label="备注:" label-width='120px'>
            <el-input v-model="submit_data.remarks" :placeholder="submit_rules.remarks.placeholder" style="width: 80%;">
            </el-input>
          </el-form-item>


        </el-form>



        <!-- 对话框底部按钮 -->
        <div style="display: flex;justify-content: center;margin-top: 20px;">
<!--          <el-button type="primary" @click="onSubmit">保存</el-button>-->
          <submitBtn @onSubmitDig="onSubmitDig" :data="submit_data" :rules="submit_rules" :url="submit_url" :JSON_Boolean="false"></submitBtn>
          <el-button @click="closeDialog">关闭</el-button>

        </div>

      </template>

    </div>




  </el-drawer>
</template>

<script>
  var _this;
  import {
    config
  } from '../../../../utils/config'; // 配置
  import axios from 'axios'; // AJAX封装类

  import 'quill/dist/quill.core.css';
  import 'quill/dist/quill.snow.css';
  import 'quill/dist/quill.bubble.css';
  import {
    quillEditor
  } from 'vue-quill-editor';
  export default {
    components: {
      quillEditor
    },
    props: {
      'isShow': Boolean,
    },
    watch: {

      isShow(newData, oldData) {

        _this.show = true;

        // 获取上传图片的地址
        this.img_upload_url = config.axios_imgURL;

        // 获取上传图片的地址
        this.img_upload_url = config.axios_imgURL

        // 清空表单数据
        for (const key in this.submit_data) {
          this.submit_data[key] = '';
        };

        // 清空图片的路径
        for (const key in this.img_url) {
          this.img_url[key] = '';
        }


      },
    },
    data() {
      return {

        show: false,


        // 图片上传地址
        img_upload_url: '',

        insideLinkList:[],

        srcList: [],

        //上传图片
        img_url: {
          cover_img_imageUrl: '',
          logo_img_imageUrl: '',
          list_img_imageUrl: ''
        },

        //压缩质量
        imgQuality: 1,



        // 上传图片的请求头
        img_headers: {

          'token': '',
          'hash-key': '',
          'platform': 'pc',
          'app-version': 'admin',
          'port': 'admin',
          'city-tag':localStorage.getItem('city_tag')

        },

        submit_url:'/advert/addAdvertSubmit',
        // 表单数据
        submit_data: {
          link: '',
          name: '',
          link_mode: '',
          content: '',
          remarks: '',
          // 封面图片
          cover_img_hash: '',
          // logo图片
          logo_img_hash: '',
          // 列表图片
          list_img_hash: '',
          origin_appid:'',
          appid:'',
          inside_link:''
        },



        submit_rules: {
          link: {
            placeholder: '请输入链接地址',
            rules: {
              required: true,
              message: '请输入链接地址格式错误',
              regulation: 'egt_str',
              rulesData: 0
            }
          },
          name: {
            placeholder: '请输入广告名称',
            rules: {
              required: true,
              message: '广告名称需在5-50字之内',
              regulation: 'between',
              rulesData: [5, 51]
            }
          },
          link_mode: {
            placeholder: '链接跳转模式',
            rules: {
              required: true,
              message: '链接跳转模式',
              regulation: 'special',
              rulesData: '0|1'
            }
          },
          content: {
            placeholder: '请输入广告内容',
            rules: {
              required: true,
              message: '广告内容',
              regulation: 'egt_str',
              rulesData: 0
            }
          },
          remarks: {
            placeholder: '',
            rules: {
              required: false,
              message: '备注输入错误',
              regulation: 'elt_str',
              rulesData: 200
            }
          },
          cover_img_hash: {
            placeholder: '',
            rules: {
              required: true,
              message: '封面图片哈希值错误',
              regulation: 'lt_str',
              rulesData: 'json_array'
            }
          },
          logo_img_hash: {
            placeholder: '',
            rules: {
              required: true,
              message: 'logo图片哈希值错误',
              regulation: 'lt_str',
              rulesData: 'json_array'
            }
          },
          list_img_hash: {
            placeholder: '',
            rules: {
              required: true,
              message: '列表图片哈希值错误',
              regulation: 'lt_str',
              rulesData: 'json_array'
            }
          },
        },

      };
    },
    created() {

      _this = this;

    },
    methods: {

      typeChange(){

        if(_this.submit_data.link_mode == '0'){

          _this.submit_data.origin_appid = '';
          _this.submit_data.appid = '';
        }else if (_this.submit_data.link_mode == '3') {
          axios.defaults.baseURL = config.axios_normalURL; //请求base url
          _this.$post(
                  '/system/getInsideLink'
          ).then(res => {
            _this.insideLinkList= res.data;

            axios.defaults.baseURL = config.axios_baseURL; //请求base url

          }).catch((err) => {

          });
          axios.defaults.baseURL = config.axios_baseURL; //请求base url
        }

      },

      // 判断图片的img_url是否存在
      imgUrlDeg() {
        if (_this.img_url.cover_img_imageUrl !== '' && _this.img_url.logo_img_imageUrl !== '' && _this
          .img_url.list_img_imageUrl !== '' && _this.img_url.id_card_hold_imageUrl !== '') {
          return true;
        } else {
          _this.$message.error("未上传图片信息")
          return false;
        }
      },

      // 身份证人像面上传成功后执行
      coverImgSuccess(res, file) {

        // 将返回的哈希值存到对应的数组中
        // _this.cover_img_arrway.push(res.data.img_hash);

        // 将返回的哈希值存到submit_data对象
        _this.submit_data.cover_img_hash = res.data.img_hash;

        // 设置img标签显示的图片路径
        _this.img_url.cover_img_imageUrl = URL.createObjectURL(file.raw);

      },


      // 身份证国徽面上传成功后执行
      logoImgSuccess(res, file) {

        // 将返回的哈希值存到对应的数组中
        // _this.logo_img_arrway.push(res.data.img_hash);

        // 将返回的哈希值存到submit_data对象
        _this.submit_data.logo_img_hash = res.data.img_hash;

        // 设置img标签显示的图片路径
        _this.img_url.logo_img_imageUrl = URL.createObjectURL(file.raw);
      },

      // 驾驶证上传成功后执行
      listImgSuccess(res, file) {

        // 将返回的哈希值存到对应的数组中
        // _this.list_img_arrway.push(res.data.img_hash);

        // 将返回的哈希值存到submit_data对象
        _this.submit_data.list_img_hash = res.data.img_hash;

        // 设置img标签显示的图片路径
        _this.img_url.list_img_imageUrl = URL.createObjectURL(file.raw);
      },


      // 图片压缩方法
      dataURItoBlob(dataURI, type) {
        var binary = atob(dataURI.split(',')[1]);
        var array = [];
        for (var i = 0; i < binary.length; i++) {
          array.push(binary.charCodeAt(i));
        }
        return new Blob([new Uint8Array(array)], {
          type: type
        });
      },


      // 图片上传之前执行的函数
      beforeAvatarUpload(file) {

        // 添加请求头
        _this.img_headers.token = localStorage.getItem(config.localStorage_token_name);
        _this.img_headers['hash-key'] = _this.$hash_key();


        return new Promise(resolve => {
          const reader = new FileReader();
          const image = new Image();
          image.onload = (imageEvent) => {
            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d');
            const width = image.width * _this.imgQuality;
            const height = image.height * _this.imgQuality;
            canvas.width = width;
            canvas.height = height;
            context.clearRect(0, 0, width, height);
            context.drawImage(image, 0, 0, width, height);
            const dataUrl = canvas.toDataURL(file.type);
            const blobData = _this.dataURItoBlob(dataUrl, file.type);
            resolve(blobData)
          }
          reader.onload = (e => {
            image.src = e.target.result;
          });
          reader.readAsDataURL(file);
        })
      },



      // 关闭方法
      closeDialog() {
        _this.show = false;
        for (const key in _this.submit_data) {
          _this.submit_data[key] = '';
        }

      },



      // 提交
      onSubmitDig() {

            // 触发父组件自定义事件刷新表格
            _this.$emit('onSubmit');
            _this.closeDialog();

      },





    }
  };
</script>

<style scoped>
  .form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }

  .el-form-second {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
  }

  .avatar-uploader {
    width: 100px;
    height: 100px;
  }

  .avatar-uploader img {
    display: block;
    width: 100%;
    height: 100%;
  }

  .verify_remarks {
    font-size: 14px;
    color: #606266;
  }

  .quill-editor {
    width: 80%;
  }
  .text-red{
    color: red;
    font-size: 14px;
  }
</style>
